// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import commonCss from './assets/css/common.css'
import commonJs from './assets/js/common'
import './assets/css/iconfont.css'
import model from './components/myComponents/model'
import PkFitMenu from './components/myComponents/PkFitMenu'
import router from './router'
import './util/extension'
import babelpolyfill from 'babel-polyfill'
import axiox from './assets/js/axios'
import page from './components/myComponents/page'
import cander from './components/myComponents/cander'
import meetCander from './components/myComponents/meetCander'
import multipleSelect from './components/myComponents/multipleSelect'
import newmultipleSelect from './components/myComponents/newmultipleSelect'
import mobileMultipleSelect from './components/myComponents/mobileMultipleSelect'
import userPicker from './components/myComponents/userPicker'
import sendPicker from './components/myComponents/sendPicker'
import selects from './components/myComponents/selects'
import allLoginName from './components/myComponents/allLoginName'
import myCharts from './assets/js/myCharts.js'
import mobileProvinceCityPicker from './components/myComponents/mobileProvinceCityPicker.vue'
import tree from './components/myComponents/tree.vue'
import allScorllPlace from './components/myComponents/allScorllPlace'
import newSelect from './components/myComponents/newSelect'
import newUserPicker from './components/myComponents/newUserPicker'
import { TimePicker,Button} from 'element-ui';
import { Icon,Toast,Overlay,Loading  } from 'vant';
Vue.component(TimePicker.name, TimePicker);
Vue.component(Button.name, Button);
Vue.config.productionTip = false
Vue.use(babelpolyfill)
Vue.use(commonCss)
Vue.use(myCharts)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Overlay)
Vue.use(Loading)



Vue.component('model', model)
Vue.component('PkFitMenu', PkFitMenu)
Vue.component('userPicker', userPicker)
Vue.component('newUserPicker', newUserPicker)
Vue.component('sendPicker', sendPicker)
Vue.component('selects', selects)
Vue.component('page', page)
Vue.component('cander', cander)
Vue.component('meetCander', meetCander)
Vue.component('logName', allLoginName)
Vue.component('allSelect', multipleSelect)
Vue.component('allSelectTwo', newmultipleSelect)
Vue.component('contentSelect', mobileMultipleSelect)
Vue.component('provinceCityPicker', mobileProvinceCityPicker)
Vue.component('allScorllPlace', allScorllPlace)
Vue.component('newSelect', newSelect)
Vue.component('tree', tree)
Vue.prototype.$commonJs = commonJs
Vue.prototype.$axiox = axiox

//定时器全局遍历
Vue.prototype.$intervalTime = '';
Vue.prototype.$intervalTimeTwo = '';

// 判断是IE几
let IENum = -1
let userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
console.log(userAgent)
let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
let isChrome = userAgent.indexOf('Chrome') > -1 // 判断是不是谷歌
let isiPad = userAgent.indexOf('iPad') > -1 // 判断是不是ipad
let isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
let isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
if (isIE) {
  let reIE = new RegExp('MSIE (\\d+\\.\\d+);')
  reIE.test(userAgent)
  let fIEVersion = parseFloat(RegExp['$1'])
  if (fIEVersion === 7) {
    IENum = 7
  } else if (fIEVersion === 8) {
    IENum = 8
  } else if (fIEVersion === 9) {
    IENum = 9
  } else if (fIEVersion === 10) {
    IENum = 10
  } else {
    IENum = 6 // IE版本<=7
  }
} else if (isEdge) {
  IENum = 'edge' // edge
} else if (isIE11) {
  IENum = 11 // IE11
} else {
  if (isChrome) {
    IENum = -1 // 是谷歌浏览器内核
  } else {
    IENum = -2 // 不是ie浏览器且不是谷歌
  }
}
Vue.prototype.$IENum = IENum
Vue.prototype.$isiPad = isiPad
// /* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
// debugger
if (window.location.href.indexOf('redirectLogin') >= 0 || window.location.href.indexOf('noPermission') > 0 || window.location.href.indexOf('register') > 0 ||
  window.location.href.indexOf('mobileContent') > 0 || window.location.href.indexOf('agreeBook') > 0 || window.location.href.indexOf('userAgreement') > 0 ||
  window.location.href.indexOf('knowledgVideoList') >= 0 || window.location.href.indexOf('favConList') >= 0 || window.location.href.indexOf('myMeetingList') >= 0 ||
  window.location.href.indexOf('articalCollections') >= 0 || window.location.href.indexOf('myPkHome') >= 0 || window.location.href.indexOf('myInstructionBook') >= 0 ||
  window.location.href.indexOf('myMinigame') >= 0 || window.location.href.indexOf('myPkIndex') >= 0 || window.location.href.indexOf('myRegistration') >= 0 ||
  window.location.href.indexOf('myOperationVideo') >= 0 || window.location.href.indexOf('myQA') >= 0 || window.location.href.indexOf('articalSearchList') >= 0 ||
  window.location.href.indexOf('login') >= 0 ||  window.location.href.indexOf('errPage') >= 0 ||  window.location.href.indexOf('myCustomCollections') >= 0 ||
  window.location.href.indexOf('articlePushManage') >= 0) {
  if (window.location.href.indexOf('register') > 0 || window.location.href.indexOf('favConList') > 0 || window.location.href.indexOf('mobileContent') > 0 || window.location.href.indexOf('agreeBook') > 0 || window.location.href.indexOf('userAgreement') > 0) {
    // document.title = '吾医空间'
    if (process.env.config.seviceUrl.indexOf('wechatweb.takeda.com.cn') > -1) {
      document.title = '吾医空间'
    } else {
      document.title = '吾医空间测试号'
    }
  }
  // eslint-disable-next-line no-new
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
} else {
  document.title = '吾医空间'
  getUserInfo()
}
// debugger
async function getUserInfo () {
  
  if (window.location.href.indexOf('favConList') < 0 && window.location.href.indexOf('meetingList') < 0 && window.location.href.indexOf('meetingDetail')) {
    // document.title = 'Takeda'
  }
  
  let loginInfo = await axiox.asyncGet('/Login/userinfo')
  Vue.prototype.$userInfo = loginInfo
  // let usermenus = await axiox.asyncGet('/api/authoritymenu/GetAllMenusByUser/usermenus?userId=' + loginInfo.id)
  let usermenus = await axiox.asyncPost('/api/authoritymenu/GetAllMenusByUser/usermenus', {userId: loginInfo.id})
  Vue.prototype.$usermenus = usermenus
  let rolesMenu = await axiox.asyncGet('/api/employeerole/Gets?pageIndex=1&pageSize=9999')
  let productList = await axiox.asyncGet('/api/product/product/querybyuserid')
  console.log(rolesMenu)
  Vue.prototype.$rolesMenu = rolesMenu
  for (let i = 0; i < rolesMenu.length; i++) {
    if (rolesMenu[i].role === 'Administrator') {
      let adminList = await axiox.asyncGet('/api/employeerole/GetEmps?roleId=' + rolesMenu[i].id + '&PageSize=9999&PageIndex=1&')
      console.log(adminList)
      let flag = false
      for (let j = 0; j < adminList.length; j++) {
        if (adminList[j].employeeId === loginInfo.id) {
          flag = true
        }
      }
      if (flag) {
        window.localStorage.setItem('isAdmin', 'true')
      } else {
        window.localStorage.setItem('isAdmin', 'false')
      }
    }
  }
  let childMenu = []
  // test
  // let item = {
  //   buttonMenus: [],
  //   childMenus: null,
  //   description: '消息管理',
  //   id: 99,
  //   isSelected: true,
  //   menuName: '消息管理',
  //   menuType: 'Default',
  //   parentMenuId: 0,
  //   tabMenus: [
  //     {
  //       buttonMenus: null,
  //       childMenus: null,
  //       description: '消息推送',
  //       id: 100,
  //       isSelected: true,
  //       menuName: '消息推送',
  //       menuType: 'Tab',
  //       parentMenuId: 99,
  //       tabMenus: null,
  //       url: 'messagePushing'
  //     },
  //     {
  //       buttonMenus: null,
  //       childMenus: null,
  //       description: '会议推送',
  //       id: 101,
  //       isSelected: true,
  //       menuName: '会议推送',
  //       menuType: 'Tab',
  //       parentMenuId: 99,
  //       tabMenus: null,
  //       url: 'meetingPushing'
  //     },
  //     {
  //       buttonMenus: null,
  //       childMenus: null,
  //       description: '消息日志',
  //       id: 102,
  //       isSelected: true,
  //       menuName: '消息日志',
  //       menuType: 'Tab',
  //       parentMenuId: 99,
  //       tabMenus: null,
  //       url: 'messageLog'
  //     }
  //   ],
  //   url: 'messagePushing'
  // }
  // usermenus.push(item)

  // let item = {
  //   buttonMenus: [],
  //   childMenus: null,
  //   description: '',
  //   id: 99,
  //   isSelected: true,
  //   menuName: '调研管理',
  //   menuType: 'Default',
  //   parentMenuId: 0,
  //   tabMenus: [
  //     {
  //       buttonMenus: null,
  //       childMenus: null,
  //       description: '调研管理',
  //       id: 100,
  //       isSelected: true,
  //       menuName: '调研管理',
  //       menuType: 'Tab',
  //       parentMenuId: 99,
  //       tabMenus: null,
  //       url: 'surveryList'
  //     },
  //     {
  //       buttonMenus: null,
  //       childMenus: null,
  //       description: '调研数据',
  //       id: 101,
  //       isSelected: true,
  //       menuName: '调研数据',
  //       menuType: 'Tab',
  //       parentMenuId: 99,
  //       tabMenus: null,
  //       url: 'surveryData'
  //     }
  //   ],
  //   url: 'surveryList'
  // }
  // usermenus.push(item)
  console.log('111---', usermenus)
  for (let i = 0; i < usermenus.length; i++) {
    for (let j = 0; j < usermenus[i].tabMenus.length; j++) {
      if (usermenus[i].tabMenus[j].isSelected) {
        childMenu.push(usermenus[i].tabMenus[j].menuName)
      }
    }
    for (let e = 0; e < usermenus[i].buttonMenus.length; e++) {
      if (usermenus[i].buttonMenus[e].isSelected) {
        childMenu.push(usermenus[i].buttonMenus[e].menuName)
      }
    }
  }
  Vue.prototype.$childMenu = childMenu
  // console.log(childMenu)
  let canEditList = await axiox.asyncGet('/api/product/cateGory/query')
  Vue.prototype.$canEditList = canEditList
  window.localStorage.setItem('userInfo', JSON.stringify(loginInfo))
  window.localStorage.setItem('usermenus', JSON.stringify(usermenus))
  window.localStorage.setItem('productList', JSON.stringify(productList))
  window.localStorage.setItem('canEditList', JSON.stringify(canEditList))
  // window.localStorage.setItem('MenuPermissions', JSON.stringify(MenuPermissions))
  // eslint-disable-next-line no-new
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
  })
}



// WEBPACK FOOTER //
// ./src/main.js